module.exports = __webpack_public_path__ + "static/img/15.9e8aeac.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15.jpeg
// module id = eBpk
// module chunks = 0